var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"py-4"},[_c('b-button',{attrs:{"to":{ name: 'AdminHome' },"variant":"success"}},[_vm._v(" Volver a home de admin ")]),_c('h1',{staticClass:"my-5 text-white"},[_vm._v("Reservas")]),_c('ReservasCalendario')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }